import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.GET_CURRENT_LANGUAGE](state) {
        return state.languages[state.current_language];
    },

    [GETTERS.GET_TRANSLATION](state, getters) {
        return (template, variables) => {
            const currentLanguage = getters[GETTERS.GET_CURRENT_LANGUAGE];
            if (currentLanguage) {
                return currentLanguage.translate(template, variables);
            }
            return template;
        };
    },
};
